<template>
  <svg viewBox="0 0 24 24" v-on="$listeners">
    <path
      d="M21 18v-8.016h-3.984v8.016h3.984zM21.984 8.016c0.516 0 1.031 0.469 1.031 0.984v9.984c0 0.516-0.516 1.031-1.031 1.031h-6c-0.516 0-0.984-0.516-0.984-1.031v-9.984c0-0.516 0.469-0.984 0.984-0.984h6zM11.016 17.484c0.844 0 1.5-0.656 1.5-1.5s-0.656-1.5-1.5-1.5-1.5 0.656-1.5 1.5 0.656 1.5 1.5 1.5zM12.984 12v1.781c0.609 0.563 1.031 1.313 1.031 2.203s-0.422 1.688-1.031 2.25v1.781h-3.984v-1.781c-0.609-0.563-0.984-1.359-0.984-2.25s0.375-1.641 0.984-2.203v-1.781h3.984zM3 6v12h3.984v2.016h-3.984c-1.078 0-2.016-0.938-2.016-2.016v-12c0-1.078 0.938-2.016 2.016-2.016h18v2.016h-18z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'devices_other',
}
</script>